<template>
  <div>
    <p
      v-if="message"
      v-b-modal.modalNotification
      class="notification"
    >{{ message }}</p>
    <b-modal
      id="modalNotification"
      no-close-on-backdrop
      hide-footer
      size="lg"
      title="Thông báo"
    >
      <div class="d-flex notify-content flex-column">
        <h3 class="titles text-uppercase text-center">
          <strong>{{ itemView.name }}</strong>
        </h3>
        <p>{{ itemView.content }}</p>
        <div class="attach_file">
          <p><strong>File đính kèm</strong></p>
          <ul>
            <li
              v-for="(item, index) in attach_file"
              :key="index"
            >
              <span
                class="linkdownload"
                @click="downloadfile(item)"
              >{{ item.name }}</span>
              <!-- <a :href="item.path"
                download>{{ item.name }}</a> -->
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import store from '@/store';
import { ref, watch } from '@vue/composition-api';
import axios from 'axios';

export default {
  setup(props, context) {
    const itemView = ref({})
    const message = ref('')
    const attach_file = ref([])
    store.dispatch('notification/show').then((response) => {
      const result = response.data;
      if (result.code == 200) {
        if (result.data) {
          itemView.value = result.data;
          message.value = result.data.name;
          attach_file.value = (result.data.attach_file) ? JSON.parse(result.data.attach_file) : []
        }
      }
    });
    return {
      itemView,
      message,
      attach_file,
    }
  },
  methods: {
    downloadfile(item) {
      axios
        .get(item.file_path, {
          headers: {
            Accept: item.mimetype,
          },
          responseType: 'blob',
        })
        .then((response) => {
          const blob = new Blob([response.data], { type: item.mimetype })
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          // link.download = item.name;
          link.setAttribute('download', `${item.name}.${item.extension}`);
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch((error) => {
          // console.log(JSON.stringify(error))
        })
    },

  },
};
</script>
